import { buildApiUrl } from "./apiConfig";

const ensureFetcher = (fetchWithAuth) => {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required.");
  }
  return fetchWithAuth;
};

export async function fetchValueConfigs(fetchWithAuth) {
  const runner = ensureFetcher(fetchWithAuth);
  const res = await runner(buildApiUrl("/admin/value-calculation-configs"));
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Value-Konfigurationen konnten nicht geladen werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.configs ?? [];
}

export async function createValueConfig(fetchWithAuth, data) {
  const runner = ensureFetcher(fetchWithAuth);
  const res = await runner(buildApiUrl("/admin/value-calculation-configs"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Value-Konfiguration konnte nicht erstellt werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.config ?? null;
}
